<template>
	<div class="producerListsModalBox">
		<el-dialog title="优先推送" :visible="isShow" width="600px" @close="close" :center="true" top="1vh">
            <div class="producerListsModalContent">
                <ul>
                    <li style="padding:0 10px;">
                        <b class="blue">已选择：{{chosedNumber}}家</b>
                    </li>
                    <!-- <li  class="itemBox thead" >
                        <span class=" iconSpan" > 
                            <i class=""></i>
                        </span>
                        <span class=" nameSpan">公司姓名</span>
                        <span class=" idSpan">公司ID</span>
                        <span class=" addressSpan">公司地址 
                        </span>
                        
                    </li> -->
                    <li v-for="(listProduce,index) in producerListsArr" class="itemBox" :class="{active:listProduce.isChosed==1}" @click="toggleList(listProduce)">
                        <span class=" iconSpan" > 
                            <!-- <i class="el-icon-success chosedIcon " ></i> -->
                            <span class="iconfont check_box_24px_rounded icon-check_box_px_rounded" v-if="listProduce.isChosed==1"></span>
                            <span class="iconfont check-box-outline-bl icon-check-box-outline-bl"   v-if="listProduce.isChosed!=1"></span>
                        </span>
                        <span class=" nameSpan">{{listProduce.company_name}} </span>
                        <!-- <span class=" idSpan">{{listProduce.user_id}} </span> -->
                        <span class=" addressSpan"> {{listProduce.address}} </span>
                    </li>
                </ul>
            </div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="close">取消</el-button>
				<el-button type="primary" @click="submit" >确定选择</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
    import api from '@/api/index.js'
    import request from '@/utils/request'
	export default {
		name: 'authmodal',
		data() {
			return {
				producerListsArr:[],
                chosedNumber:0,
			}
		},
		props:['isShow','hadChosedArr'],
		components: {},
		computed: {
		},
		methods: {
            getProducerLists() {
                let _this = this
                let arg={}
                console.log("开始获取生产商列表")
                request({
                    url: api.producerList,
                    data: arg
                }).then(function(res) {
                    if (res.errorCode == 200) {
                        let newArr=res.data.map((item,index)=>{
                            item.isChosed=false
                            return item
                        })
                        _this.producerListsArr=JSON.parse(JSON.stringify(res.data)) 
                    }
                }, function(res) {})
            },
            resetProducerLists(){
                let _this=this
                let newArr=_this.producerListsArr.map((item,index)=>{
                    let isChosedResult=false
                    _this.chosedNumber=_this.hadChosedArr.length
                    _this.hadChosedArr.forEach(function(item2,index2){
                        if(item2.user_id==item.user_id){
                            isChosedResult=1
                        }
                    })
                    item.isChosed=isChosedResult
                    return item
                })
                _this.producerListsArr=newArr
            },
            toggleList(list){
                console.log(list)
                if(list.isChosed==1){
                    list.isChosed=false
                    this.chosedNumber-=1
                }else{
                    list.isChosed=1
                    this.chosedNumber+=1
                }
            },
			refresh(){
				this.$emit('submitSuccessFun',this.producerListsArr);
			},
			submit(){
				let _this=this
                _this.close()
                _this.refresh()
				
			},
			close(){
				console.log("emit close")
				this.$emit('close');
			}
		},
		mounted() {
            this.getProducerLists()
		}
	}
</script>

<style scoped lang="scss">
	.producerListsModalContent{
         height: 400px;     min-width: 500px;  overflow: auto;
        .itemSpan{display: inline-block;margin-right: 20px;}
        .itemBox:hover{background: #fff;cursor: pointer;}
        .itemBox.active{border:1px solid #fff;background: #fff; }
        .itemBox.active{
            font-weight: bold;
            .iconSpan,.nameSpan{color:blue;}
        }
        .itemBox.thead{background: #fff;color:#333;}
        .itemBox{
            background: #fff; border:1px solid #fff;
            padding:5px 5px;; font-size: 14px;
            .iconSpan{display: inline-block; width: 50px ;}
            .nameSpan{display: inline-block; width: 220px ;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap; margin-right: 10px;
            
            }  
            .idSpan{display: inline-block; width: 70px ;} 
            .addressSpan{display: inline-block; min-width: 170px ;}
        } 
    }
</style>
